"use client"

import { ArrowDownIcon } from "@src/icons"
import { useEffect, useRef, useState } from "react"
import AssetComboIcon from "../DefuseSDK/components/Asset/AssetComboIcon"
import StatusFooter from "./StatusFooter"

const swapTokens = [
  {
    symbol: "USDC",
    amount: "5000",
    value: "$5000",
    icon: "/static/icons/token/usdc.svg",
  },
  {
    symbol: "BTC",
    amount: "0.0771",
    value: "$4999.3",
    icon: "/static/icons/token/btc.svg",
  },
]

const swapDetails = [
  { label: "Exchange rate", value: "1 BTC = 64,850.84 USDC" },
  { label: "Max slippage", value: "0.50%" },
  { label: "Receive at least", value: "0.076715 BTC" },
] as const

const swapStates = ["Finding best price", "Executing swap", "Swap successful"]

const SwapIllustration = ({ isActive = true }: { isActive?: boolean }) => {
  const rootRef = useRef<HTMLDivElement>(null)
  const [isInView, setIsInView] = useState(false)
  const [hasStarted, setHasStarted] = useState(false)

  useEffect(() => {
    const element = rootRef.current
    if (!element) {
      return
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry?.isIntersecting) {
          setIsInView(true)
        }
      },
      { threshold: 0.4 }
    )

    observer.observe(element)
    return () => observer.disconnect()
  }, [])

  useEffect(() => {
    if (isActive && isInView) {
      setHasStarted(true)
    }
  }, [isActive, isInView])

  return (
    <div
      ref={rootRef}
      className="w-full max-w-[min(85vw,26rem)] space-y-1 rounded-2xl border border-white/5 bg-gray-900 p-1"
    >
      <div className="flex flex-col gap-4 rounded-xl border border-white/5 bg-gray-850 p-5">
        <div className="flex items-center gap-3">
          <AssetComboIcon icon={swapTokens[0].icon} sizeClassName="size-12" />
          <div className="flex flex-col">
            <div className="font-semibold text-base/5 text-white tracking-tight">
              {swapTokens[0].amount} {swapTokens[0].symbol}
            </div>
            <div className="font-medium text-gray-400 text-sm/5">
              {swapTokens[0].value}
            </div>
          </div>
        </div>

        <div className="flex w-12 items-center justify-center">
          <ArrowDownIcon className="size-6 text-gray-400" />
        </div>

        <div className="flex items-center gap-3">
          <AssetComboIcon icon={swapTokens[1].icon} sizeClassName="size-12" />
          <div className="flex flex-col">
            <div className="font-semibold text-base/5 text-white tracking-tight">
              {swapTokens[1].amount} {swapTokens[1].symbol}
            </div>
            <div className="font-medium text-gray-400 text-sm/5">
              {swapTokens[1].value}
            </div>
          </div>
        </div>
      </div>

      <div className="flex flex-col gap-2.5 rounded-xl border border-white/5 bg-gray-850 p-5">
        {swapDetails.map(({ label, value }) => (
          <div key={label} className="flex items-center justify-between gap-2">
            <div className="font-medium text-gray-400 text-sm/5">{label}</div>
            <div className="text-right font-semibold text-sm/5 text-white">
              {value}
            </div>
          </div>
        ))}
      </div>

      <StatusFooter states={swapStates} isPlaying={hasStarted} />
    </div>
  )
}

export default SwapIllustration
